import CheckboxInput from './checkbox-input';

export default CheckboxInput;
